import { buildInventoryForm, inventorySubmit } from "./helper";

jQuery(function ($) {
  const apiToken =
    "eyJpdiI6ImtrTm0xTSsrTHBkdk5yMEJmcndSWHc9PSIsInZhbHVlIjoiWTJQS3ZRVDI3ai9RQ0RkUUZScEIzVE90V2VRbGFuWjh6dTVqYzRvSjVXRT0iLCJtYWMiOiI0MTM0MWYyMDZiNTMxZmE2YjZhMzgyNGMzOTdiZjkzOWE2OGI3YzIzOGZiMjA2OWE5YjIxYTNmNTMxODFkNWU4IiwidGFnIjoiIn0=";

  const url = "https://accesspass.io";

  var idBTN;
  var homeIDbtn;
  dayjs.extend(window.dayjs_plugin_customParseFormat);

  if ($("#event-now").length || $("#event-binn").length) {
    callNowEvents();
    callComingEvents();

    $(document).on("click", ".event-now-btn", function () {
      idBTN = $(this).data("id");
      // console.log(idBTN);
      window.location.href = `/agenda-detail?eventID=${idBTN}`;
    });

    $(document).on("click", ".event-binn-btn", function () {
      idBTN = $(this).data("id");
      // console.log(idBTN);
      window.location.href = `/agenda-detail?eventID=${idBTN}`;
    });
  }

  if ($("#event-home-lg").length) {
    eventHomeLg();
    $(document).on("click", ".agenda-lg", function () {
      homeIDbtn = $(this).data("id");
      window.location.href = `/agenda-detail?eventID=${homeIDbtn}`;
    });
  }

  if ($("#event-home-md").length || $("#event-hero-home").length) {
    eventHeroHome();
    eventHomeMd();

    $(document).on("click", ".agenda-md-btn", function () {
      homeIDbtn = $(this).data("id");
      window.location.href = `/agenda-detail?eventID=${homeIDbtn}`;
    });

    $(document).on("click", ".hero-btn", function () {
      homeIDbtn = $(this).data("id");
      window.location.href = `/agenda-detail?eventID=${homeIDbtn}`;
    });
  }

  var queryParams = new URLSearchParams(window.location.search);
  var detailID = queryParams.get("eventID");

  if ($("#event-content").length && detailID) {
    console.log(detailID);
    const loaderElement = document.querySelector(".loader");
    loaderElement.classList.add("active");
    callEventContent(detailID);
    relatedEvents(detailID);
    $(document).on("click", ".related-btn", function () {
      detailID = $(this).data("id");
      window.location.href = `/agenda-detail?eventID=${detailID}`;
    });
  }

  if ($("#event-archief").length) {
    callEventAchief();

    $(document).on("click", ".event-archief-btn", function () {
      idBTN = $(this).data("id");
      console.log(idBTN);
      window.location.href = `/agenda-detail?eventID=${idBTN}`;
    });
  }

  function eventHeroHome() {
    const loaderElements = document.querySelectorAll(".loader");

    loaderElements.forEach((loaderElement) => {
      loaderElement.classList.add("active");
    });
    // console.log("homepage hero API ready");
    const settings = {
      url: url + "/api/homepage/list",
      method: "GET",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
        "Api-Token": apiToken,
      },
      error: function (error) {
        console.log("error", error);
      },
    };
    $.ajax(settings).done(function (response) {
      console.log("response", response);

      if (response.result.data != "") {
        const imagesData = []; // Array to store the extracted data

        response.result.data.forEach((item) => {
          const dateEndStr = item.end_date;
          const dateEndObj = new Date(dateEndStr);
          const dayEnd = dateEndObj.getDate();
          const monthEnd = dateEndObj.toLocaleString("default", {
            month: "short",
          });
          const formattedDateEnd = `${dayEnd} ${monthEnd}`;
          imagesData.push({
            id: item.id,
            image: item.image,
            title: item.title,
            subtitle: item.subtitle,
            date: formattedDateEnd,
            text: item.text,
            variation: item.variation,
          });
        });

        var size = imagesData.length;
        var randomIndex = Math.floor(size * Math.random());
        var randomImageObject = imagesData[randomIndex];

        // console.log("Random Index:", randomIndex);
        // console.log("Random Image Object:", randomImageObject);

        const eventImageHero = $("#event-hero-home-img");
        eventImageHero.attr("src", randomImageObject.image);

        if (size > 0) {
          if (randomImageObject.variation == 1) {
            if (randomImageObject.text == "white") {
              var divHero = $(`
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-v.svg" class="invert object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class="textContainer text-white lg:p-8 col-span-3 row-span-2 flex flex-col justify-center">
                  <div class="md:text-[22px] xl:text-[26px] font-degularDisplay font-semibold pb-4">${randomImageObject.date}</div>
                  <div class="md:text-[38px] xl:text-[90px] font-degularDisplay font-bold md:leading-[40px] xl:leading-[70px] xl:pb-8">${randomImageObject.title}</div>
                  <div class="md:text-[20px] xl:text-[26px] font-degularDisplay font-semibold md:leading-[22px] lg:leading-[26px]">
                  ${randomImageObject.subtitle}
                  </div>
                  <div class="py-4 md:flex gap-10 items-center">
                    <button id="btn-doen" class="hero-btn mb-4 w-full md:w-auto pt-2 pb-1 px-5 rounded-full pil-btn-white border text-black bg-white  border-white relative flex items-center justify-center cursor-pointer hover:bg-black hover:text-white" data-id=${randomImageObject.id}>
                      <span class="mr-2 text-lg font-degularText pb-1">lees verder</span>
                    </button>
                  </div>
                </div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-n.svg" class="invert object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-k.svg" class="invert object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
              `);
            } else if (randomImageObject.text == "black") {
              var divHero = $(`
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-v.svg" class="invert-0 object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class="textContainer text-black lg:p-8 col-span-3 row-span-2 flex flex-col justify-center">
                  <div class="md:text-[22px] xl:text-[26px] font-degularDisplay font-semibold">${randomImageObject.date}</div>
                  <div class="md:text-[38px] xl:text-[90px] font-degularDisplay font-bold md:leading-[40px] xl:leading-[70px] xl:pb-8">${randomImageObject.title}</div>
                  <div class="md:text-[20px] xl:text-[26px] font-degularDisplay font-semibold md:leading-[22px] lg:leading-[26px]">
                  ${randomImageObject.subtitle}
                  </div>
                  <div class="py-4 md:flex gap-10 items-center">
                    <button id="btn-doen" class="hero-btn mb-4 w-full md:w-auto pt-2 pb-1 px-5 rounded-full pil-btn-black border text-white bg-black border-black relative flex items-center justify-center cursor-pointer hover:bg-white hover:text-black" data-id=${randomImageObject.id}>
                      <span class="mr-2 text-lg font-degularText pb-1">lees verder</span>
                    </button>
                  </div>
                </div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-n.svg" class="invert-0 object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-k.svg" class="invert-0 object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
            `);
            } else {
            }
          } else if (randomImageObject.variation == 2) {
            if (randomImageObject.text == "white") {
              var divHero = $(`
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-v.svg" class="invert object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class="textContainer text-white lg:p-8 col-span-3 row-span-2 flex flex-col justify-center">
                  <div class="md:text-[22px] xl:text-[26px] font-degularDisplay font-semibold">${randomImageObject.date}</div>
                  <div class="md:text-[38px] xl:text-[90px] font-degularDisplay font-bold md:leading-[40px] xl:leading-[70px] xl:pb-8">${randomImageObject.title}</div>
                  <div class="md:text-[20px] xl:text-[26px] font-degularDisplay font-semibold md:leading-[22px] lg:leading-[26px]">
                  ${randomImageObject.subtitle}
                  </div>
                  <div class="py-4 md:flex gap-10 items-center">
                    <button id="btn-doen" class="hero-btn mb-4 w-full md:w-auto pt-2 pb-1 px-5 rounded-full pil-btn-white border text-black bg-white  border-white relative flex items-center justify-center cursor-pointer hover:bg-black hover:text-white" data-id=${randomImageObject.id}>
                      <span class="mr-2 text-lg font-degularText pb-1">lees verder</span>
                    </button>
                  </div>
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-n.svg" class="invert object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-k.svg" class="invert object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
              `);
            } else if (randomImageObject.text == "black") {
              var divHero = $(`
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-v.svg" class="invert-0 object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class="textContainer text-black lg:p-8 col-span-3 row-span-2 flex flex-col justify-center">
                  <div class="md:text-[22px] xl:text-[26px] font-degularDisplay font-semibold">${randomImageObject.date}</div>
                  <div class="md:text-[38px] xl:text-[90px] font-degularDisplay font-bold md:leading-[40px] xl:leading-[70px] xl:pb-8">${randomImageObject.title}</div>
                  <div class="md:text-[20px] xl:text-[26px] font-degularDisplay font-semibold md:leading-[22px] lg:leading-[26px]">
                  ${randomImageObject.subtitle}
                  </div>
                  <div class="py-4 md:flex gap-10 items-center">
                    <button id="btn-doen" class="hero-btn mb-4 w-full md:w-auto pt-2 pb-1 px-5 rounded-full pil-btn-black border text-white bg-black border-black relative flex items-center justify-center cursor-pointer hover:bg-white hover:text-black" data-id=${randomImageObject.id}>
                      <span class="mr-2 text-lg font-degularText pb-1">lees verder</span>
                    </button>
                  </div>
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-n.svg" class="invert-0 object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-k.svg" class="invert-0 object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
            `);
            } else {
            }
          } else if (randomImageObject.variation == 3) {
            if (randomImageObject.text == "white") {
              var divHero = $(`
                <div class=""></div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-v.svg" class="invert object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-n.svg" class="invert object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class="textContainer text-white lg:p-8 col-span-3 row-span-2 flex flex-col justify-center">
                  <div class="md:text-[22px] xl:text-[26px] font-degularDisplay font-semibold">${randomImageObject.date}</div>
                  <div class="md:text-[32px] xl:text-[90px] font-degularDisplay font-bold md:leading-[40px] xl:leading-[70px] xl:pb-8">${randomImageObject.title}</div>
                  <div class="md:text-[20px] xl:text-[26px] font-degularDisplay font-semibold md:leading-[22px] lg:leading-[26px]">
                  ${randomImageObject.subtitle}
                  </div>
                  <div class="py-4 md:flex gap-10 items-center">
                    <button id="btn-doen" class="hero-btn mb-4 w-full md:w-auto pt-2 pb-1 px-5 rounded-full pil-btn-white border text-black bg-white  border-white relative flex items-center justify-center cursor-pointer hover:bg-black hover:text-white" data-id=${randomImageObject.id}>
                      <span class="mr-2 text-lg font-degularText pb-1">lees verder</span>
                    </button>
                  </div>
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-k.svg" class="invert object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
              `);
            } else if (randomImageObject.text == "black") {
              var divHero = $(`
                <div class=""></div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-v.svg" class="invert-0 object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-n.svg" class="invert-0 object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class="textContainer text-black lg:p-8 col-span-3 row-span-2 flex flex-col justify-center">
                  <div class="md:text-[22px] xl:text-[26px] font-degularDisplay font-semibold">${randomImageObject.date}</div>
                  <div class="md:text-[38px] xl:text-[90px] font-degularDisplay font-bold md:leading-[40px] xl:leading-[70px] xl:pb-8">${randomImageObject.title}</div>
                  <div class="md:text-[20px] xl:text-[26px] font-degularDisplay font-semibold md:leading-[22px] lg:leading-[26px]">
                  ${randomImageObject.subtitle}
                  </div>
                  <div class="py-4 md:flex gap-10 items-center">
                    <button id="btn-doen" class="hero-btn mb-4 w-full md:w-auto pt-2 pb-1 px-5 rounded-full pil-btn-black border text-white bg-black border-black relative flex items-center justify-center cursor-pointer hover:bg-white hover:text-black" data-id=${randomImageObject.id}>
                      <span class="mr-2 text-lg font-degularText pb-1">lees verder</span>
                    </button>
                  </div>
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class="">
                  <img src="themes/custom/tema/src/assets/letter-k.svg" class="invert-0 object-cover w-auto" style="height:clamp(80px, 10vw, 200px)">
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
                <div class=""></div>
            `);
            } else {
            }
          }

          if (randomImageObject.text == "white") {
            var divMobile = $(`
            <div class="font-degularDisplay text-white text-[22px] leading-[22px] font-semibold">${randomImageObject.date}</div>
            <div class="font-degularDisplay text-white text-[48px] leading-[48px] font-bold">${randomImageObject.title}</div>
          `);
          } else if (randomImageObject.text == "black") {
            var divMobile = $(`
            <div class="font-degularDisplay text-black text-[22px] leading-[22px] font-semibold">${randomImageObject.date}</div>
            <div class="font-degularDisplay text-black text-[48px] leading-[48px] font-bold">${randomImageObject.title}</div>
          `);
          }
          // const divContainer = $("#event-hero-home");
          // divContainer.empty();
          // divContainer.append(divHero);

          const divContainer = $("#event-hero-home");
          const divContainerSm = $("#event-hero-home-sm");
          divContainer.empty();
          divContainerSm.empty();
          divContainer.append(divHero);
          divContainerSm.append(divMobile);
        }
        loaderElements.forEach((loaderElement) => {
          loaderElement.classList.remove("active");
        });
      } else {
        const eventImageHero = $("#event-hero-home-img");
        eventImageHero.attr(
          "src",
          "themes/custom/tema/src/assets/hero-home-default.png"
        );
        loaderElements.forEach((loaderElement) => {
          loaderElement.classList.remove("active");
        });
      }
    });
    const loaderElement = document.querySelector(".loader");
    loaderElement.classList.remove("active");
  }

  function eventHomeLg() {
    console.log("homepage event lg API ready");
    const settings = {
      url: url + "/api/event/franchisees/now",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
        "Api-Token": apiToken,
      },
      error: function (error) {
        console.log("error", error);
      },
    };
    $.ajax(settings).done(function (response) {
      console.log("response", response);

      const events = response.result.data;
      const firstTwoEvents = events.slice(0, 2);

      const divHomelg = $("#event-home-lg-api");
      divHomelg.empty();

      // Loop through the first two events and display them
      firstTwoEvents.forEach(function (item) {
        const divBtn = $("#agenda-lg-btn");
        divBtn.empty();
        const button = $("<button>", {
          class:
            "agenda-lg gap-3 align-bottom pil-btn-white w-full md:w-auto mb-4 pt-2 pb-1 px-5 rounded-full border text-black dark:text-white bg-white dark:bg-black border-black dark:border-white relative flex items-center justify-center cursor-pointer hover:bg-black hover:text-white hover:border-white dark:hover:bg-white dark:hover:text-black dark:hover:border-black",
          "data-id": item.id,
          html: '<span class="pb-1">lees verder</span>',
        });

        // Append the button to the div or container
        divBtn.append(button);

        //image
        if (item.image != null) {
          const eventImageHero = $("#event-homelg-image");
          eventImageHero.attr("src", item.image);
        }

        //title
        if (item.title != null) {
          $("#event-homelg-title").text(item.title);
        }

        if (item.subtitle != null) {
          $("#event-homelg-subtitle").text(item.subtitle);
        }

        //tags
        if (item.tags != null) {
          const tagContainer = $("#event-homelg-tags");
          const tagsArray = item.tags;
          tagContainer.empty();
          tagsArray.forEach((tag) => {
            const tagElement = $(`
              <div class="inline-block my-4 pt-0 pb-1 px-3 rounded-full border text-white dark:text-black bg-black dark:bg-white border-white dark:border-black relative cursor-pointer">
                <span class="text-sm font-degularText font-normal uppercase tracking-[0.7px]">${tag}</span>
              </div>
            `);
            tagContainer.append(tagElement);
          });
        }

        //date NU
        if (item.start_date != item.end_date) {
          $("#event-homelg-date").html(
            "Van " +
              item.start_date +
              " t/m " +
              item.end_date +
              " - " +
              item.location
          );
        }

        // Get the HTML content of the element with id="event-binn"
        const eventHomelgHtml =
          document.getElementById("event-home-lg").innerHTML;
        divHomelg.append(eventHomelgHtml);
      });

      const loaderElement = document.querySelector(".loader");
      loaderElement.classList.remove("active");
    });
  }

  function eventHomeMd() {
    console.log("homepage event md API ready");
    const settings = {
      url: url + "/api/event/franchisees/now",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
        "Api-Token": apiToken,
      },
      error: function (error) {
        console.log("error", error);
      },
    };
    $.ajax(settings).done(function (response) {
      console.log("response", response);

      const divHomemd = $("#event-home-md-api");
      divHomemd.empty();

      // Process the first two items only
      for (let i = 0; i < 2 && i < response.result.data.length; i++) {
        const item = response.result.data[i];

        const divBtn = $("#agenda-md-btn");
        divBtn.empty();
        const button = $("<button>", {
          class:
            "agenda-md-btn gap-3 align-bottom pil-btn-white w-full md:w-auto mb-4 pt-2 pb-1 px-5 rounded-full border text-black dark:text-white bg-white dark:bg-black border-black dark:border-white relative flex items-center justify-center cursor-pointer hover:bg-black hover:text-white hover:border-white dark:hover:bg-white dark:hover:text-black dark:hover:border-black",
          "data-id": item.id,
          html: '<span class="pb-1">lees verder</span>',
        });

        // Append the button to the div or container
        divBtn.append(button);

        //image
        if (item.image != null) {
          const eventImageHero = $("#event-homemd-image");
          eventImageHero.attr("src", item.image);
        }

        //title
        if (item.title != null) {
          $("#event-homemd-title").text(item.title);
        }

        if (item.subtitle != null) {
          $("#event-homemd-subtitle").text(item.subtitle);
        }

        //tags
        if (item.tags != null) {
          const tagContainer = $("#event-homemd-tags");
          const tagsArray = item.tags;
          tagContainer.empty();
          tagsArray.forEach((tag) => {
            const tagElement = $(`
                    <div class="inline-block my-4 pt-0 pb-1 px-3 rounded-full border text-white dark:text-black bg-black dark:bg-white border-white dark:border-black relative cursor-pointer">
                      <span class="text-sm font-degularText font-normal uppercase tracking-[0.7px]">${tag}</span>
                    </div>
                  `);
            tagContainer.append(tagElement);
          });
        }

        //date NU
        if (item.start_date != item.end_date) {
          $("#event-homemd-date").html(
            "Van " +
              item.start_date +
              " t/m " +
              item.end_date +
              " - " +
              item.location
          );
        }

        // Get the HTML content of the element with id="event-binn"
        const eventHomemdHtml =
          document.getElementById("event-home-md").innerHTML;
        divHomemd.append(eventHomemdHtml);
      }
      const loaderElement = document.querySelector(".loader");
      loaderElement.classList.remove("active");
    });
  }

  function callNowEvents() {
    const loaderElements = document.querySelectorAll(".loader");

    loaderElements.forEach((loaderElement) => {
      loaderElement.classList.add("active");
    });
    console.log("nu te zien API ready");
    const settings = {
      url: url + "/api/event/franchisees/now",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
        "Api-Token": apiToken,
      },
      error: function (error) {
        console.log("error", error);
      },
    };
    $.ajax(settings).done(function (response) {
      console.log("response", response);

      const divNow = $("#event-now-api");
      divNow.empty();
      response.result.data.forEach((item) => {
        // $("#event-now-id").text(item.id);

        const divBtn = $("#event-now-btn");
        divBtn.empty();
        const button = $("<button>", {
          class:
            "event-now-btn gap-3 align-bottom pil-btn-white w-full md:w-auto mb-4 pt-2 pb-1 px-5 rounded-full border text-black dark:text-white bg-white dark:bg-black border-black dark:border-white relative flex items-center justify-center cursor-pointer hover:bg-black hover:text-white hover:border-white dark:hover:bg-white dark:hover:text-black dark:hover:border-black",
          "data-id": item.id,
          html: '<span class="pb-1">lees verder</span>',
        });

        // Append the button to the div or container
        divBtn.append(button);

        //image
        if (item.image != null) {
          const eventImageHero = $("#event-now-image-now");
          eventImageHero.attr("src", item.image);
        }

        //title
        if (item.title != null) {
          $("#event-now-title").text(item.title);
        }

        if (item.subtitle != null) {
          $("#event-now-subtitle").text(item.subtitle);
        }

        //tags
        if (item.tags != null) {
          const tagContainer = $("#event-now-tags");
          const tagsArray = item.tags;
          tagContainer.empty();
          tagsArray.forEach((tag) => {
            const tagElement = $(`
              <div class="inline-block my-4 pt-0 pb-1 px-3 rounded-full border text-white dark:text-black bg-black dark:bg-white border-white dark:border-black relative cursor-pointer">
                <span class="text-sm font-degularText font-normal uppercase tracking-[0.7px]">${tag}</span>
              </div>
            `);
            tagContainer.append(tagElement);
          });
        }

        //date NU
        if (item.start_date != item.end_date) {
          $("#event-now-date").html(
            "Van " +
              item.start_date +
              " t/m " +
              item.end_date +
              " - " +
              item.location
          );
        }
        const eventNowHtml = document.getElementById("event-now").innerHTML;
        divNow.append(eventNowHtml);

        loaderElements.forEach((loaderElement) => {
          loaderElement.classList.remove("active");
        });
      });
    });
  }

  function callComingEvents() {
    console.log("binnenkort API ready");
    const settings = {
      url: url + "/api/event/franchisees/coming",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
        "Api-Token": apiToken,
      },
      error: function (error) {
        console.log("error", error);
      },
    };
    $.ajax(settings).done(function (response) {
      console.log("response", response);
      const loaderElement = document.querySelector("#loader-binn");
      loaderElement.classList.remove("active");

      const divBinn = $("#event-binn-api");
      divBinn.empty();

      response.result.data.forEach((item) => {
        const dateStartStr = item.start_date;
        const dateStartObj = dayjs(dateStartStr, "D MMMM YYYY", "nl");
        const dayStart = dateStartObj.date();
        const monthStart = dateStartObj.format("MMM");

        const formattedDateStart = `${dayStart} ${monthStart}`;

        const dateEndStr = item.end_date;
        const dateEndObj = dayjs(dateEndStr, "D MMMM YYYY", "nl");
        const dayEnd = dateEndObj.date();
        const monthEnd = dateEndObj.format("MMM");

        const formattedDateEnd = `${dayEnd} ${monthEnd}`;

        console.log("snap", item.id);
        const divBtn = $("#event-binn-btn");
        divBtn.empty();
        const button = $("<button>", {
          class:
            "event-binn-btn gap-3 align-bottom pil-btn-white w-full md:w-auto mb-4 pt-2 pb-1 px-5 rounded-full border text-black dark:text-white bg-white dark:bg-black border-black dark:border-white relative flex items-center justify-center cursor-pointer hover:bg-black hover:text-white hover:border-white dark:hover:bg-white dark:hover:text-black dark:hover:border-black",
          "data-id": item.id,
          html: '<span class="pb-1">lees verder</span>',
        });

        // Append the button to the div or container
        divBtn.append(button);

        // $(".event-binn-btn").attr("data-id", item.id);
        //image
        if (item.image != null) {
          const eventImageHero = $("#event-binn-image-now");
          eventImageHero.attr("src", item.image);
        }

        //title
        if (item.title != null) {
          $("#event-binn-title").text(item.title);
        }

        if (item.subtitle != null) {
          $("#event-binn-subtitle").text(item.subtitle);
        }

        //tags
        if (item.tags != null) {
          const tagContainer = $("#event-binn-tags");
          const tagsArray = item.tags;
          tagContainer.empty();
          tagsArray.forEach((tag) => {
            const tagElement = $(`
            <div class="inline-block my-4 pt-0 pb-1 px-3 rounded-full border text-white dark:text-black bg-black dark:bg-white border-white dark:border-black relative cursor-pointer">
              <span class="text-sm font-degularText font-normal uppercase tracking-[0.7px]">${tag}</span>
            </div>
          `);
            tagContainer.append(tagElement);
          });
        }

        //date NU
        if (item.start_date != item.end_date) {
          $("#event-binn-date").html(
            "Van " +
              item.start_date +
              " t/m " +
              item.end_date +
              " - " +
              item.location
          );
        } else if (item.start_date == item.end_date) {
          $("#event-binn-date").html(
            item.start_date + " uur - " + item.location
          );
        }

        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, "0");
        const month = new Intl.DateTimeFormat("en-US", {
          month: "short",
        }).format(currentDate);
        const year = currentDate.getFullYear();
        const formattedDate = `${day} ${month} ${year}`;
        console.log(formattedDate); // Output: "03 Aug 2023"

        //date datum
        if (item.start_date != item.end_date) {
          $("#event-binn-datum").html(
            formattedDateStart
            // formattedDateStart + "<br>" + formattedDateEnd
          );
        } else if (
          item.start_date == item.end_date &&
          item.start_date == formattedDate
        ) {
          $("#event-binn-datum").html("NU");
        } else {
          $("#event-binn-datum").html(item.start_date);
        }

        // Get the HTML content of the element with id="event-binn"
        const eventBinnHtml = document.getElementById("event-binn").innerHTML;
        divBinn.append(eventBinnHtml);

        // loaderElements.forEach((loaderElement) => {
        //   loaderElement.classList.remove("active");
        // });
      });
    });
  }

  function formatLineBreaks(text) {
    return text.replace(/\r\n|\n/g, "<br>");
  }

  function callEventContent(id) {
    console.log("event detail API ready");
    const settings = {
      url: url + "/api/event/get/" + id,
      method: "GET",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
        "Api-Token": apiToken,
      },
      error: function (error) {
        console.log("error", error);
      },
    };
    $.ajax(settings).done(function (response) {
      console.log("response", response);

      const loaderElement = document.querySelector(".loader");
      loaderElement.classList.remove("active");

      //hero image
      if (response.result.image != null) {
        const eventImageHero = $("#event-detail-image-hero");
        eventImageHero.attr("src", response.result.image);
        eventImageHero.attr("loading", "lazy");
      }

      //id
      if (response.result.id != null) {
        var id = response.result.id;
        $("#event-detail-id").attr("data-id", response.result.id);
        if (response.result.inventories.length > 0) {
          $("#event-detail-id").attr("data-hasinventory", "true");
        }
      }

      //quotes
      var qInfoDivs = document.querySelectorAll(".quotes-info");

      var quotesInAgenda = [];

      if (qInfoDivs != null) {
        qInfoDivs.forEach(function (div) {
          var tags = JSON.parse(div.getAttribute("data-quotes"));

          tags.forEach((tag) => {
            if (tag.agendaID == response.result.id) {
              quotesInAgenda.push({
                quotes: [tag], // Push only the tag that matches agendaID
              });
            }
          });
        });

        console.log(quotesInAgenda);

        if (quotesInAgenda.length > 0) {
          $("#quotes-block").removeClass("hidden");
          var quoteCount = 0;
          quoteCount = quotesInAgenda.length;
          const quoteContainer = $("#event-detail-quotes");
          const quotecarousel = $("<div class='event-quote-carousel'></div>");

          quotesInAgenda.forEach((tagObj) => {
            var quotes = tagObj.quotes;
            if (quotes.length > 0) {
              quotes.forEach((quote) => {
                const quoteElement = $(`

                    <div>
                      <div class="flex items-center flex-col-reverse lg:flex-row flex-wrap py-4">

                        <div class="w-full md:pb-8">
                          <div class="pb-4">
                            <img src="themes/custom/tema/src/assets/icons/icon-quote-open.svg" class="invert-0 dark:invert transition-all h-5 w-5 lg:h-6 lg:w-6">
                          </div>


                          <div class="text-base lg:text-lg font-normal break-words">${quote.quote}</div>


                          <div class="pt-4 flex justify-end">
                            <img src="themes/custom/tema/src/assets/icons/icon-quote-close.svg" class="invert-0 dark:invert transition-all h-5 w-5 lg:h-6 lg:w-6">
                          </div>
                        </div>

                        <div class="w-full px-2 md:px-0 pb-8 lg:pb-0">
                          <div class="flex items-center gap-4 lg:gap-10">
                              <img src="${quote.image}" alt="${quote.altText}" class="h-[60px] w-[60px] lg:h-[120px] lg:w-[120px] rounded-[10px]">

                            <div class="font-degularText">
                              <div class="text-base lg:text-lg font-semibold">${quote.name}</div>

                              <div class="flex lg:block">
                                <div class="text-base lg:text-lg font-normal mr-2 lg:mr-0">${quote.company}</div>
                                <div class="lg:hidden"> | </div>
                                <div class="text-base lg:text-lg font-normal ml-2 lg:ml-0">${quote.position}</div>
                              </div>

                            </div>
                          </div>
                        </div>



                      </div>
                    </div>
                  `);
                quotecarousel.append(quoteElement);
              });
            }
          });
          quoteContainer.append(quotecarousel);

          console.log(quoteCount);
          const carouselBtn = $("#event-detail-quotes-button");

          if (quoteCount > 1) {
            var quotesButton = $(`
              <div class="btn-wrap-quote-event flex justify-center lg:justify-end">
                <button class="flex items-center gap-4 prev-btn-quote text-white dark:text-black">
                  <img src="themes/custom/tema/src/assets/icons/arrow-white-left.svg" class="invert-0 dark:invert transition-all" height="18px" width="18px">
                  <span class="text-base lg:text-lg font-degularText">vorige</span>
                </button>
                <button class="flex items-center gap-4 next-btn-quote text-white dark:text-black">
                  <span class="text-base lg:text-lg font-degularText">volgende</span>
                  <img src="themes/custom/tema/src/assets/icons/arrow-white-right.svg" class="invert-0 dark:invert transition-all" height="18px" width="18px">
                </button>
              </div>
            `);
          }
          carouselBtn.append(quotesButton);
        }

        $(".event-quote-carousel").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
        });

        $(".prev-btn-quote").click(function () {
          $(".event-quote-carousel").slick("slickPrev");
        });

        $(".next-btn-quote").click(function () {
          $(".event-quote-carousel").slick("slickNext");
        });
        $(".prev-btn-quote").addClass("slick-disabled");
        $(".event-quote-carousel").on("afterChange", function () {
          if (
            $(".event-quote-carousel .slick-prev").hasClass("slick-disabled")
          ) {
            $(".prev-btn-quote").addClass("slick-disabled");
          } else {
            $(".prev-btn-quote").removeClass("slick-disabled");
          }
          if (
            $(".event-quote-carousel .slick-next").hasClass("slick-disabled")
          ) {
            $(".next-btn-quote").addClass("slick-disabled");
          } else {
            $(".next-btn-quote").removeClass("slick-disabled");
          }
        });
      }

      const currentDate = new Date();
      const day = String(currentDate.getDate()).padStart(2, "0");
      const month = new Intl.DateTimeFormat("en-US", { month: "short" }).format(
        currentDate
      );
      const year = currentDate.getFullYear();
      const formattedDate = `${day} ${month} ${year}`;
      // console.log(formattedDate); // Output: "03 Aug 2023"

      //infomatie
      if (response.result.location.name != null) {
        $("#event-detail-info-location").text(response.result.location.name);
      }

      if (
        response.result.contact_name != null &&
        response.result.contact_company != null
      ) {
        $("#event-detail-info-name").html(
          response.result.contact_name +
            " <br> " +
            response.result.contact_company
        );
      }

      var dateNow = new Date(formattedDate);
      var dateEvent = new Date(response.result.end_date);
      const isSingleDay =
        response.result.start_date === response.result.end_date;

      //the event in the past
      if (dateNow > dateEvent) {
        //if the event date is NOOOOOTTTT "Single day"
        if (!isSingleDay) {
          $("#event-detail-info-date").html(
            "Deze activiteit heeft" +
              " <br> " +
              "plaatsgevonden vanaf" +
              " <br> " +
              response.result.start_date +
              " <br> " +
              " t/m " +
              response.result.end_date
          );
          //the event date is "Single day"
        } else {
          $("#event-detail-info-date").html(
            "Deze activiteit heeft" +
              " <br> " +
              "plaatsgevonden op" +
              " <br> " +
              response.result.start_date
          );
        }
      }
      //the event date is in the future
      else if (dateNow < dateEvent) {
        //the event is not "Single day"
        if (!isSingleDay) {
          $("#event-detail-info-date").html(
            "Deze activiteit vindt" +
              " <br> " +
              "plaats vanaf" +
              " <br> " +
              response.result.start_date +
              " <br> " +
              " t/m " +
              response.result.end_date
          );
          //the event is "Single Day"
        } else {
          $("#event-detail-info-date").html(
            "Deze activiteit vindt" +
              " <br> " +
              "plaats op" +
              " <br> " +
              response.result.start_date
          );
        }
      }

      //the event is happening now
      else {
        if (!isSingleDay) {
          $("#event-detail-info-date").html(
            "Van " +
              response.result.start_date +
              " <br> " +
              " t/m " +
              response.result.end_date +
              " <br> " +
              response.result.time +
              " uur"
          );
          //event is in the future
        } else {
          $("#event-user-date").html(
            response.result.start_date +
              " <br> " +
              response.result.time +
              " uur"
          );
        }

        $("#event-detail-info-date").html(response.result.start_date);
      }

      //informatie btn
      var seatTotal = response.result.seat_total;
      // var seatAvail = 0;
      var seatAvail = response.result.seat_available;
      var threshold = seatTotal * 0.1;

      if (seatAvail <= threshold && seatAvail != 0) {
        $("#less-seat").removeClass("hidden");
      } else if (seatAvail == 0) {
        // console.log({seatAvail})
        $("#register-btn").addClass("hidden");
        $("#no-seat").removeClass("hidden");
      }
      //if event has already happened hide the register button
      else if (dateNow > dateEvent) {
        $("#register-btn").addClass("hidden");
      } else {
        // console.log("nothing...");
      }

      //title
      if (response.result.title != null) {
        $("#event-detail-title").text(response.result.title);
      }

      //tags
      if (response.result.tags != null) {
        const tagContainer = $("#event-detail-tags");
        const tagsArray = response.result.tags;
        tagContainer.empty();
        tagsArray.forEach((tag) => {
          const tagElement = $(`
          <div class="inline-block my-4 pt-0 pb-1 px-3 rounded-[40px] border text-white dark:text-black bg-black dark:bg-white border-white dark:border-black relative cursor-pointer">
            <span class="text-sm font-degularText font-normal uppercase tracking-[0.7px]">${tag}</span>
          </div>
        `);
          tagContainer.append(tagElement);
        });
      }

      //subtitle
      if ($("#event-detail-subtitle").html().trim() !== '') {
        $("#event-detail-subtitle").html(
          formatLineBreaks(response.result.subtitle)
        );
      }

      //intro
      if ($("#event-detail-intro").html().trim() !== '') {
        $("#event-detail-intro").html(
          formatLineBreaks(response.result.introduction)
        );
      }

      //more text
      if (response.result.description != null) {
        $("#descrp-block").removeClass("hidden");
        $("#event-detail-description").html(
          formatLineBreaks(response.result.description)
        );
      }

      if (response.result.additional_info != null) {
        $("#additionalDescription-block").removeClass("hidden");
        $("#event-detail-additional").html(
          formatLineBreaks(response.result.additional_info)
        );
      }

      //download
      const downloadsContainer = $("#event-detail-download");
      if (response.result.files != null) {
        $("#download-block").removeClass("hidden");
        $("#download-title").text("Download");
        response.result.files.forEach(function (file) {
          const downloadLink = `
          <div class="flex items-center gap-4">
            <a href="${file.url}" download target="_blank" class="">
              <img src="themes/custom/tema/src/assets/icons/download-btn.svg" class="invert-0 dark:invert transition-all h-12 w-12 lg:h-12 lg:w-12">
            </a>
            <div>
              <div class="text-lg font-degularText font-bold">${file.name}</div>
              <div class="text-lg font-degularText">${file.organisation}</div>
            </div>
          </div>
        `;
          downloadsContainer.append(downloadLink);
        });
      }

      //speakers
      const speakersContainer = $("#event-detail-speaker");
      if (
        response.result.speakers.data != null &&
        response.result.speakers.data.length > 0
      ) {
        $("#speaker-block").removeClass("hidden");
        $("#speaker-title").text("Sprekers");
        response.result.speakers.data.forEach((speaker) => {
          const speakerElement = `
          <div class="flex items-center gap-12 py-4">
            <img src="${speaker.image}" class="block w-[140px] h-[140px] md:rounded-[10px]">
            <div>
              <div class="text-lg font-degularText font-semibold">${speaker.name}</div>
              <div class="flex">
                <div class="text-lg font-degularText">${speaker.position} - ${speaker.company}</div>
              </div>
              <div class="text-lg font-degularText">${speaker.notes}</div>
            </div>
          </div>
        `;
          speakersContainer.append(speakerElement);
        });
      }

      //photo gallery
      if (response.result.medias != null) {
        $("#photo-block").removeClass("hidden");
        const mediaArray = response.result.medias;
        const carouselImagesContainer = $("#event-detail-gallery");
        const gallerycarousel = $("<div class='event-media-carousel'></div>");

        mediaArray.forEach((media) => {
          const imageUrl = media.url;
          const imageElement = `<img src="${imageUrl}" alt="" class="md:rounded-[10px]">`;
          gallerycarousel.append(imageElement);
        });

        if (Array.isArray(mediaArray)) {
          const mediaCount = mediaArray.length;
          console.log("Number of media URLs:", mediaCount);

          const carouselBtn = $("#event-detail-gallery-button");

          if (mediaCount > 1) {
            var galleryButton = $(`
            <div class="btn-wrap-gallery-event flex justify-center lg:justify-end">
              <button class="flex items-center gap-4 prev-btn-event text-white dark:text-black">
                <img src="themes/custom/tema/src/assets/icons/arrow-white-left.svg" class="invert-0 dark:invert transition-all" height="18px" width="18px">
                <span class="text-base lg:text-lg font-degularText">vorige</span>
              </button>
              <button class="flex items-center gap-4 next-btn-event text-white dark:text-black">
                <span class="text-base lg:text-lg font-degularText">volgende</span>
                <img src="themes/custom/tema/src/assets/icons/arrow-white-right.svg" class="invert-0 dark:invert transition-all" height="18px" width="18px">
              </button>
            </div>
          `);
          }
          carouselBtn.append(galleryButton);
        }

        carouselImagesContainer.append(gallerycarousel);

        $(".event-media-carousel").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        });

        $(".prev-btn-event").click(function () {
          $(".event-media-carousel").slick("slickPrev");
        });

        $(".next-btn-event").click(function () {
          $(".event-media-carousel").slick("slickNext");
        });
        $(".prev-btn-event").addClass("slick-disabled");
        $(".event-media-carousel").on("afterChange", function () {
          if (
            $(".event-media-carousel .slick-prev").hasClass("slick-disabled")
          ) {
            $(".prev-btn-event").addClass("slick-disabled");
          } else {
            $(".prev-btn-event").removeClass("slick-disabled");
          }
          if (
            $(".event-media-carousel .slick-next").hasClass("slick-disabled")
          ) {
            $(".next-btn-event").addClass("slick-disabled");
          } else {
            $(".next-btn-event").removeClass("slick-disabled");
          }
        });
      }

      //location
      if (response.result.location != null) {
        $("#location-block").removeClass("hidden");
        $("#location-title").text("Locatie");
        function detailInitMap() {
          const latitudeString = response.result.location.latitude;
          const latitudeFloat = parseFloat(latitudeString);
          const longitudeString = response.result.location.longitude;
          const longitudeFloat = parseFloat(longitudeString);

          var myLatlng = new google.maps.LatLng(latitudeFloat, longitudeFloat);

          var mapOptions = {
            zoom: 15,
            center: myLatlng,
            draggable: true,
            scrollwheel: false,
            mapTypeControl: false,
            zoomControl: true,
            streetViewControl: false,
            styles: [
              {
                featureType: "poi",
                elementType: "labels",
                stylers: [
                  {
                    visibility: "off", // Hide poi labels
                  },
                ],
              },
              {
                featureType: "transit",
                elementType: "labels",
                stylers: [
                  {
                    visibility: "off", // Hide transit labels
                  },
                ],
              },
            ],
          };

          var detailMapElement = document.getElementById("detail-map-canvas");
          if (detailMapElement) {
            var map = new google.maps.Map(detailMapElement, mapOptions);
          }

          var markerIcon = {
            url: "themes/custom/tema/src/assets/icons/map-marker-black.svg", // URL of the marker button image
            // size: new google.maps.Size(32, 32), // Size of the marker button image
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(16, 16), // Anchor point of the marker button image
          };

          var marker = new google.maps.Marker({
            position: myLatlng,
            map: map,
            title: "Hello World!",
            icon: markerIcon,
          });
        }

        var detailMapCanvas = document.getElementById("detail-map-canvas");

        if (detailMapCanvas) {
          detailInitMap();
        }

        if ($("#event-detail-location-note").html().trim() !== '') {
          $("#event-detail-location-note").html(
            formatLineBreaks(response.result.location.description)
          );
        }

        $("#event-detail-location-address").html(
          response.result.location.name +
            "<br>" +
            response.result.location.address +
            "<br>" +
            response.result.location.postcode +
            "&nbsp;" +
            response.result.location.state +
            "&nbsp;" +
            response.result.location.country
        );
      }

      //inventories

      if (response.result.inventories.length > 0) {
        buildInventoryForm(response.result.inventories, response.result.title, response.result.id);
        inventorySubmit();
      }
    });
  }

  $(".close-inventory-button").click(function () {
    console.log('closing')
    $(".modal-inventory").removeClass("show-modal-news");
    const pathname = window.location.pathname;

// Check if the pathname ends with '/page1'
if (pathname.endsWith('/mijnprofiel')) {
    location.reload();
  }
  });


  function callEventAchief() {
    const loaderElements = document.querySelectorAll(".loader");

    loaderElements.forEach((loaderElement) => {
      loaderElement.classList.add("active");
    });
    console.log("archief API ready");
    const settings = {
      url: url + "/api/event/franchisees/archive",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
        "Api-Token": apiToken,
      },
      error: function (error) {
        console.log("error", error);
      },
    };
    $.ajax(settings).done(function (response) {
      console.log("response", response);

      const divArchive = $("#event-archief-api");
      divArchive.empty();
      response.result.data.forEach((item) => {
        const dateStartStr = item.start_date;
        const dateStartObj = dayjs(dateStartStr, "D MMMM YYYY", "nl");
        const dayStart = dateStartObj.date();
        const monthStart = dateStartObj.format("MMM");

        const formattedDateStart = `${dayStart} ${monthStart}`;

        const dateEndStr = item.end_date;
        const dateEndObj = dayjs(dateEndStr, "D MMMM YYYY", "nl");
        const dayEnd = dateEndObj.date();
        const monthEnd = dateEndObj.format("MMM");

        const formattedDateEnd = `${dayEnd} ${monthEnd}`;

        const divArchiefBtn = $("#event-archief-btn");
        divArchiefBtn.empty();
        const Archiefbutton = $("<button>", {
          class:
            "event-archief-btn gap-3 align-bottom pil-btn-white w-full md:w-auto mb-4 pt-2 pb-1 px-5 rounded-full border text-black dark:text-white bg-white dark:bg-black border-black dark:border-white relative flex items-center justify-center cursor-pointer hover:bg-black hover:text-white hover:border-white dark:hover:bg-white dark:hover:text-black dark:hover:border-black",
          "data-id": item.id,
          html: '<span class="pb-1">lees verder</span>',
        });

        // Append the button to the div or container
        divArchiefBtn.append(Archiefbutton);

        //image
        if (item.image != null) {
          const eventImageHero = $("#event-archief-image");
          eventImageHero.attr("src", item.image);
        }

        //title
        if (item.title != null) {
          $("#event-archief-title").text(item.title);
        }

        if (item.subtitle != null) {
          $("#event-archief-subtitle").text(item.subtitle);
        }

        //tags
        if (item.tags != null) {
          const tagContainer = $("#event-archief-tags");
          const tagsArray = item.tags;
          tagContainer.empty();
          tagsArray.forEach((tag) => {
            const tagElement = $(`
            <div class="inline-block my-4 pt-0 pb-1 px-3 rounded-full border text-white dark:text-black bg-black dark:bg-white border-white dark:border-black relative cursor-pointer">
              <span class="text-sm font-degularText font-normal uppercase tracking-[0.7px]">${tag}</span>
            </div>
          `);
            tagContainer.append(tagElement);
          });
        }

        //date NU
        if (item.start_date != item.end_date) {
          $("#event-archief-date").html(
            "Van " +
              item.start_date +
              " t/m " +
              item.end_date +
              " - " +
              item.location
          );
        } else if (item.start_date == item.end_date) {
          $("#event-archief-date").html(
            item.start_date + " uur - " + item.location
          );
        }

        //date datum
        if (item.start_date != item.end_date) {
          $("#event-archief-datum").html(
            formattedDateEnd
            // formattedDateStart + "<br>" + formattedDateEnd
          );
        } else {
          $("#event-archief-datum").html(
            formattedDateStart
            // formattedDateStart + "<br>" + formattedDateEnd
          );
        }

        // Get the HTML content of the element with id="event-binn"
        const eventArchiveHtml =
          document.getElementById("event-archief").innerHTML;
        divArchive.append(eventArchiveHtml);

        loaderElements.forEach((loaderElement) => {
          loaderElement.classList.remove("active");
        });
      });
    });
  }

  function relatedEvents(id) {
    var thisEvent = id;
    console.log("thisEvent :", thisEvent);
    var responseDataArray = [];
    console.log("related ready");
    const Nowsettings = {
      url: url + "/api/event/franchisees/now",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
        "Api-Token": apiToken,
      },
      error: function (error) {
        console.log("error", error);
      },
    };

    const Comingsettings = {
      url: url + "/api/event/franchisees/coming",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
        "Api-Token": apiToken,
      },
      error: function (error) {
        console.log("error", error);
      },
    };

    $.when($.ajax(Nowsettings), $.ajax(Comingsettings)).done(function (
      nowResponse,
      comingResponse
    ) {
      const nowData = nowResponse[0];
      const comingData = comingResponse[0];

      // Push data from both responses into responseDataArray
      nowData.result.data.forEach(function (item) {
        responseDataArray.push(item);
      });

      comingData.result.data.forEach(function (item) {
        responseDataArray.push(item);
      });

      console.log("related", responseDataArray);
      console.log("hel", responseDataArray.length);

      if (responseDataArray.length <= 1) {
        $("#related-block").removeClass("hidden");
        $("#related-title").text("Sorry no related events.");
      } else {
        $("#related-block").removeClass("hidden");
        $("#related-title").text("Gerelateerde evenementen");
      }

      var count = 0;
      if (responseDataArray.length > 1) {
        const divRelated = $("#event-related-api");
        divRelated.empty();

        responseDataArray.forEach(function (item) {
          if (item.id != thisEvent && count < 2) {
            const divBtn = $("#related-btn");
            divBtn.empty();
            const button = $("<button>", {
              class:
                "related-btn gap-3 align-bottom pil-btn-white w-full md:w-auto mb-4 pt-2 pb-1 px-5 rounded-full border text-black dark:text-white bg-white dark:bg-black border-black dark:border-white relative flex items-center justify-center cursor-pointer hover:bg-black hover:text-white hover:border-white dark:hover:bg-white dark:hover:text-black dark:hover:border-black",
              "data-id": item.id,
              html: '<span class="pb-1">lees verder</span>',
            });

            // Append the button to the div or container
            divBtn.append(button);

            //image
            if (item.image != null) {
              const eventImageHero = $("#event-related-image");
              eventImageHero.attr("src", item.image);
            }

            //title
            if (item.title != null) {
              $("#event-related-title").text(item.title);
            }

            if (item.subtitle != null) {
              $("#event-related-subtitle").text(item.subtitle);
            }

            //tags
            if (item.tags != null) {
              const tagContainer = $("#event-related-tags");
              const tagsArray = item.tags;
              tagContainer.empty();
              tagsArray.forEach((tag) => {
                const tagElement = $(`
                  <div class="inline-block my-4 pt-0 pb-1 px-3 rounded-full border text-white dark:text-black bg-black dark:bg-white border-white dark:border-black relative cursor-pointer">
                    <span class="text-sm font-degularText font-normal uppercase tracking-[0.7px]">${tag}</span>
                  </div>
                `);
                tagContainer.append(tagElement);
              });
            }

            //date NU
            if (item.start_date != item.end_date) {
              $("#event-related-date").html(
                "Van " +
                  item.start_date +
                  " t/m " +
                  item.end_date +
                  " - " +
                  item.location
              );
            } else if (item.start_date == item.end_date) {
              $("#event-related-date").html(
                item.start_date + " uur - " + item.location
              );
            }

            const currentDate = new Date();
            const day = String(currentDate.getDate()).padStart(2, "0");
            const month = new Intl.DateTimeFormat("en-US", {
              month: "short",
            }).format(currentDate);
            const year = currentDate.getFullYear();
            const formattedDate = `${day} ${month} ${year}`;
            console.log(formattedDate); // Output: "03 Aug 2023"

            const dateStartStr = item.start_date;
            const dateStartObj = dayjs(dateStartStr, "D MMMM YYYY", "nl");
            const dayStart = dateStartObj.date();
            const monthStart = dateStartObj.format("MMM");

            const formattedDateStart = `${dayStart} ${monthStart}`;

            const dateEndStr = item.end_date;
            const dateEndObj = dayjs(dateEndStr, "D MMMM YYYY", "nl");
            const dayEnd = dateEndObj.date();
            const monthEnd = dateEndObj.format("MMM");

            const formattedDateEnd = `${dayEnd} ${monthEnd}`;

            //date datum
            if (item.start_date != item.end_date) {
              $("#related-datum").html(
                formattedDateStart
                // formattedDateStart + "<br>" + formattedDateEnd
              );
            } else if (
              item.start_date == item.end_date &&
              item.start_date == formattedDate
            ) {
              $("#related-datum").html("NU");
            } else {
              $("#related-datum").html(formattedDateStart);
            }

            // Get the HTML content of the element with id="event-binn"
            const eventRelatedHtml =
              document.getElementById("event-related").innerHTML;
            divRelated.append(eventRelatedHtml);

            count++;
            console.log("yayyy");
          }
        });

        const loaderElement = document.querySelector(".loader");
        loaderElement.classList.remove("active");
      }
    }); //when

    // var count = 0;
    // if (responseDataArray.length > 1) {

    // }
  }

  //check if the user has already registered for an event
  function getEventIDFromURL() {
    var urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.get("eventID");
  }

  function isIdInArray(id, array) {
    console.log(array.indexOf(id));
    return array.indexOf(id) !== -1;
  }

  // Check if an ID is present in the registeredEvent array
  function checkIdInRegisteredEvent(id) {
    var registeredEvents =
      JSON.parse(localStorage.getItem("registeredEvent")) || [];
    return isIdInArray(id, registeredEvents);
  }

  const loginToken = localStorage.getItem("login-token");

  // console.log(checkIdInRegisteredEvent(parseInt(getEventIDFromURL())))
  // Call the function to check if an ID is in the array
  // must check that the user is logged in as well
  if (
    checkIdInRegisteredEvent(parseInt(getEventIDFromURL())) &&
    loginToken !== null
  ) {
    $("#register-btn").hide();
    $("#event-registered").css("display", "flex");
  }

  if (loginToken === null) {
    console.log("user is not logged in, add trigger login");
    $("#register-btn").hide();
    $("#login-btn").css("display", "flex");
  }
}); //js
